import React from "react";
import CouponTable from "components/Tables/coupon/CouponTable";

const ListCoupon = () => {
  return (
    <div>
      <CouponTable />
    </div>
  );
};

export default ListCoupon;
